import Vue from 'vue';

Vue.filter('currency', function (value, currency = 'HUF') {
  if (!currency) {
    currency = 'HUF';
  }
  return new Intl.NumberFormat('hu', {
    style: 'currency',
    currency,
    minimumSignificantDigits: 1,
    maximumFractionDigits: 2,
  }).format(parseFloat(value).toFixed(2))
    .replace(/\D00$/, '');
});
